// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

/* Services */
angular.module('hqServices', ['ngResource']).
    factory('AccountSetup', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/signup/:token', {}, {});
    }]).
    factory('Logs', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/logs/', {}, {
            queryNotifications: { method: 'GET', cache: false, isArray: true, params: { isNotification: true }},            
            acknowledge: { method: 'POST', cache: false, url: baseUrl + 'api/v1/logs/acknowledge/' },
            queryArchived: {
                method: 'GET', cache: false, isArray: true, params: { isNotification: true }, url: baseUrl + 'api/v1/logs/archive'
            },
            queryCollections: {
                method: 'GET', cache: true, isArray: false, url: baseUrl + 'api/v1/logs/archivedCollections'
            }
        })
    }]).
    factory('RequestLogsWeb', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/requestLogs/', {}, {
            single: { method: 'GET', isArray: false, url: baseUrl + 'api/v1/requestLogs/:id' },
        });
    }]).
    factory('RequestLogsHQ', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/requestLogs/hq', {}, {});
    }]).
    factory('User', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Users/', {}, {});
    }]).
    factory('EmailAddressesDownload', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Users/downloadlink', {}, {});
    }]).
    factory('AdminUser', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/AdminUsers/', {}, {
        });
    }]).
    factory('CurrentOp', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/CurrentOps/', {}, {
        });
    }]).
    factory('Entity', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Entities/:entityId', {}, {
            patch: { method: 'PATCH' }
        });
    }]).
    factory('EntityHierarchy', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Entities/hierarchy/:entityId', {}, {
            get: { method: 'GET' }
        });
    }]).
    factory('EntitySettings', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Entities/:entityId/settings', {}, {
            update: { method: 'PUT', params: {} }
        });
    }]).
    factory('SingleCustomer', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/SingleCustomer/:entityId', {}, {
            searchByName: { method: 'GET', isArray: true, url: baseUrl + 'api/v1/SingleCustomer', params: { name: '@name', offset: '@offset', limit: '@limit' } },
            link: { method: 'POST', url: baseUrl + 'api/v1/SingleCustomer' }
        });
    }]).
    factory('Email', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Emails/', {}, {
        });
    }]).
    factory('Migration', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Migrations/', {}, {
            queryImportant: { method: 'GET', isArray: true, url: baseUrl + 'api/v1/Migrations/important'}
        });
    }]).
    factory('OAuthGrants', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/OAuthGrants/', {}, {
        });
    }]).
    factory('OAuthClients', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/OAuthClients/', {}, {
        });
    }]).
    factory('Profiler', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/DBProfiler/', {}, {
        });
    }]).
    factory('LockedContract', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/LockedContracts/', {}, {
        });
    }]).
    factory('PrometheusAction', ['$resource', function ($resource) {
        const actionsUrl = 'api/v1/PrometheusActions/';
        return $resource(baseUrl + actionsUrl, {}, {
            getNames: { method: 'GET', url: `${baseUrl}${actionsUrl}names`, isArray: true }
        });
    }]).
    factory('PrometheusInstance', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/PrometheusInstance/', {}, {
        });
    }]).
    factory('Job', ['$resource', function ($resource) {
        const jobsUrl = 'api/v1/Jobs/';
        return $resource(baseUrl + jobsUrl, {}, {
            getTypes: { method: 'GET', url: `${baseUrl}${jobsUrl}types`, isArray: true }
        });
    }]).
    factory('ProfilerSettings', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/DBProfilerSettings/', {}, {
        });
    }]).
    factory('Settings', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/settings/', {}, {
            update: { method: 'PUT', params: {} }
        });
    }]).
    factory('PgSystemSettings', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/paymentGateway/systemSettings/', {}, {
            update: { method: 'PUT', params: {} }
        });
    }]).
    factory('SettingsSimulation', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/settings/simulation/', {}, {});
    }]).
    factory('DeploymentInfo', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/DeploymentInfo/', {}, {
            });
        }]).
    factory('RateLimit', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/RateLimits/', {}, {
        });
    }]).
    factory('Signup', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/signup/', {}, {});
    }]).
    factory('PasswordSettings', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/account/password', {}, {
            update: { method: 'PUT', params: {} }
        });
    }]).
    factory('PaymentTransactions', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/paymentTransactions/:transactionId', {}, {
        });
    }]).
    factory('ThirdPartyRequests', ['$resource', function($resource){
          return $resource(baseUrl + 'api/v1/thirdpartyintegrationsrequestlog', {}, {
        });
    }]).
    factory('ThirdPartyRequestDetails', ['$resource', function($resource){
        return $resource(baseUrl + 'api/v1/thirdpartyintegrationsrequestlog/getbyid/:requestId', {}, { 
        });
      }]). 
    factory('PaymentLogs', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/paymentLogs/:transactionId', {}, {
        });
    }]).
    factory('PaymentSessions', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/paymentSessions/:sessionId', {}, {
        });
    }]).
    factory('PSPTransactionData', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/paymentTransactions/:transactionId/pspData', {}, {
        });
    }]).
    factory('Orders', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/orders', {}, {
        });
    }]).
    factory('Webhook', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/webhooks/:webhookId', {}, {
            update: { method: 'PUT', params: {} }
        });
    }]).
    factory('SuspendedHook', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/SuspendedWebhooks/:id', {}, {
        });
    }]).
    factory('DashboardOverview', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Dashboard/overview/', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('DashboardFeatureStats', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Dashboard/feature-stats/', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('DashboardPSPStats', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Dashboard/psp-stats/', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('DashboardMonthly', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Dashboard/monthly/', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('DashboardTurnovers', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Dashboard/turnovers/', {}, {
            //query: { method: 'GET', isArray: true }
        });
    }]).
    factory('DBObjects', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Dashboard/dbobject/:objectid', {}, {
        });
    }]).
    factory('AttendanceAll', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Attendance/', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('Attendance', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/Attendance/:type/:period', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('AccountSettings', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/account', {}, {
            update: { method: 'PUT', params: {} }
        });
    }]).
    factory('Customer', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/customers/:customerId', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('Contract', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/customers/:customerId/contracts', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('LedgerEntry', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/customers/:customerId/ledgerentries', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('EntityNames', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entitynames', {}, {});
    }]).
    factory('UserNames', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/usernames', {}, {});
    }]).
    factory('PSPSettings', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/pspsettings', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('ThirdPartyIntegrationSettings', ['$resource', '$http', function ($resource, $http) {
        let service = $resource(baseUrl + 'api/v1/entities/:entityId/thirdpartyintegrationsettings', {}, {
            query: { method: 'GET', isArray: true },
            externalProviderAuthenticationSettings: {
                method: 'GET', isArray: true, url: baseUrl + 'api/v1/entities/thirdpartyintegrationsettings/externalProviderAuthenticationSettings'
            }
        });

        service.delete = function (id, callback) {
            return $http({
                method: 'DELETE',
                url: 'api/v1/thirdpartyintegrationsettings/' + id
            }).success(callback);
        }

        return service;
    }]).
    factory('ImportWebhookLogs', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/thirdpartywebhooklog', {}, {
        });
    }]).
    factory('InvoiceDraft', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/invoicedrafts', {}, {
        });
    }]).
    factory('Invoice', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/invoices/:id', {}, {
        });
    }]).
    factory('Dunning', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/dunnings/:id', {}, {
        });
    }]).
    factory('ReconFileImport', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/reconfileimports', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('RatedItem', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/rateditems', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('MeteredUsage', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/meteredusages', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('ProductInfo', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/productInfo', {}, {
        });
    }]).
    factory('InvoiceDownload', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/invoices/:id/downloadLink', {}, {
        });
    }]).
    factory('DunningDownload', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/dunnings/:id/downloadLink', {}, {
        });
    }]).
    factory('MigrationReadiness', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/migrationreadiness/:id', {}, {
            // The entity has a single check, addressed without an id, so the URL is spelled out rather than
            // left to depend on how $resource drops an unset trailing parameter.
            current: { method: 'GET', url: baseUrl + 'api/v1/entities/:entityId/migrationreadiness' }
        });
    }]).
    factory('MigrationReadinessDownload', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/migrationreadiness/:id/downloadlink', {}, {
        });
    }]).
    factory('ReconFileDownload', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/reconfileimports/:id/downloadLink', {}, {
        });
    }]).
    factory('ReconFileDownloadByImportFileId', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/reconfileimports/:id/file/downloadLink', {}, {
        });
    }]).
    factory('CheckPasswordStrength', ['$http', function ($http) {
        return $resource(baseUrl + 'api/v1/signup/checkpassword/:id', {}, {});
    }]).
    factory('CheckPasswordStrength', ['$http', function ($http) {
        return function (password, callback) {
            $http({
                method: "POST",
                url: "api/v1/checkpassword",
                data: { "password": password },
                headers: {},
                cache: false
            }).success(callback);
        };
    }]).
    factory('Throttle', [
        '$timeout', function ($timeout) {
            function throttle(action, delay, callback) {
                var result = {};
                var outstandingVersion = 0; // requested by the consumer, but might not have been requested yet
                var requestedVersion = 0; // action has been called
                var availableVersion = 0; // response is available for this version
                var timeout = null;

                function request() {
                    timeout = null;
                    if (outstandingVersion === requestedVersion)
                        return;
                    requestedVersion = outstandingVersion;

                    var requestVersion = outstandingVersion;
                    action(result.outstandingRequest, callback2);

                    function callback2(response) {
                        if (requestVersion < availableVersion)// block out-of-order arrivals
                            return;
                        availableVersion = requestVersion;
                        result.response = response;
                        result.isCurrent = availableVersion === outstandingVersion;
                        if (callback)
                            callback(response);
                    }
                }

                result.request = function (data) {
                    result.outstandingRequest = data;
                    outstandingVersion++;
                    if (!timeout) {
                        request();
                        timeout = $timeout(request, delay);
                    }
                }

                return result;
            }
            return throttle;
        }
    ]).
    factory('LedgerEscalation', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/customers/:customerId/ledgerescalations', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('UserCount', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/users/count', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('CustomerCount', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/customers/count', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('ContractCount', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/contracts/count', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('InvoiceDraftCount', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/invoiceDrafts/count', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('InvoiceCount', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/invoices/count', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('DunningCount', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/entities/:entityId/dunnings/count', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('VatIdValidationResult', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/vatidvalidationresult/', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('WorkerProcess', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/WorkerProcess/', {}, {
            query: { method: 'GET', isArray: true }
        });
    }]).
    factory('FileStorageConfiguration', ['$resource', function ($resource) {
    return $resource(baseUrl + 'api/v1/fileStorageConfiguration/', {}, {
            query: { method: 'GET', isArray: false }  
        });
    }]).
    factory('PSPConfiguration', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/creditCards/', {}, {
            query: { method: 'GET', isArray: true }  
        });
    }]).
    factory('PrepaidCard', ['$resource', function($resource) {
        return $resource(baseUrl + 'api/v1/prepaidcard/all');
    }]).
    factory('PrepaidCardCount', ['$resource', function($resource) {
        return $resource(baseUrl + 'api/v1/prepaidcard/count', {}, {
            query: { method: 'GET', isArray: false }
        });
    }]).
    factory('PrometheusLog', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/prometheusLog/', {}, {
            query: { method: 'GET', isArray: true },
            pspLogs: {method: 'GET', isArray :true, url: baseUrl + 'api/v1/prometheusLog/pspLogs' }})
    }]).factory('ExternalSubscriptionRequestLogs', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/externalSubscriptionRequestLogs/', {}, {
            query: { method: 'GET', isArray: true },
            getEnums: { method: 'GET', isArray: false, cache: true, url: baseUrl + 'api/v1/externalSubscriptionRequestLogs/getEnums' }
        });
    }]).factory('PaymentGatewayTransactions', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/paymentGateway/transactions', {}, {});
    }]).factory('PaymentGatewayTransactionsUtils', ['$resource', function ($resource) {

        const util = $resource(baseUrl + 'api/v1/paymentGateway/transactions', {}, {});

        util.identifyTransactionType = function (transaction) {

            if (transaction == null)
                return '';
            
            if (transaction.IsInitial === true) {
                let isInitialPayment = transaction.BillwerkCaptureTransactionId === undefined;
                return isInitialPayment ? "Preauth" : "Initial Payment"
            }

            let isRefundTransaction = transaction.TargetPaymentTransactionId !== undefined;
            return isRefundTransaction ? "Refund" : "Payment";
        }
        
        return util;
    }]).factory('PgMigrations', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/paymentGateway/migrations', {}, { });
    }]).factory('PgApplicationLogs', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/paymentGateway/logs/app', {}, { });
    }]).factory('PgNotificationLogs', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/paymentGateway/logs/notification', {}, { });
    }]).factory('PgPspRequestLogs', ['$resource', function ($resource) {
        return $resource(baseUrl + 'api/v1/paymentGateway/logs/psprequest', {}, { });
    }]).factory('PgRequestLogs', ['$resource', function ($resource) {
        return  $resource(baseUrl + 'api/v1/paymentGateway/logs/pgrequest', {}, { });
    }]).factory('PgPspReports', ['$resource', function ($resource) {
        return  $resource(baseUrl + 'api/v1/paymentGateway/pspReports', {}, { })
    }]).factory('BackbeatAction', ['$resource', function ($resource) {
        const actionsUrl = 'api/v1/BackbeatActions/';
        return $resource(baseUrl + actionsUrl, {}, {
            getNames: { method: 'GET', url: `${baseUrl}${actionsUrl}names`, isArray: true },
            setActionStatus: { method: 'POST', params:{id: '@id'}, url: `${baseUrl}${actionsUrl}:id/state`},
            resetTimestamp: { method: 'POST', params:{id: '@id'}, url: `${baseUrl}${actionsUrl}:id/reset`},
            requeue: { method: 'POST', params:{id: '@id'}, url: `${baseUrl}${actionsUrl}:id/requeue`},
        });
    }]).factory('PgLogsWithAcknowledge', ['$resource', function ($resource) {        
        return $resource(baseUrl + 'api/v1/paymentGateway/logs/logswithacknowledge/', {}, {
            queryLogs: { method: 'GET', cache: false, isArray: true},
            acknowledge: { method: 'POST', cache: false, url: baseUrl + 'api/v1/paymentGateway/logs/acknowledge/' },
            acknowledgeById: { method: 'POST', params:{id: '@id'}, cache: false, url: baseUrl + 'api/v1/paymentGateway/logs/acknowledge/:id' },
        });        
    }]);
